import { Grid, TextField } from '@material-ui/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { capitalizeFirstLetter } from '../../../../../../utils/capitalizeFirstLetter';
import { stringifyNumber } from '../../../../../../utils/stringifyNumber';
import styles from './EditPricingDeposit.module.scss';
import { numberWithCommas } from '../../../../../../utils/numberWithCommas';
import { percentage } from '../../../../../../utils/percentage';
import { ConstructionOutlined } from '@mui/icons-material';
import { makeStyles, withStyles } from '@material-ui/styles';
import { useStyles } from '@material-ui/pickers/views/Calendar/SlideTransition';
import { setDepositSchedule } from '../../../../../../api/Agreement/setDepositSchedule.api';
import { useParams } from 'react-router';
import CustomTextField from '../../../../../layout/customTextField/CustomTextField';
import _ from 'lodash';
import CustomDateField from '../../../../../layout/customDateField/CustomDateField';

const EditPricingDeposit = ({
	depositSchedule,
	totalCost,
	depositScheduleData,
	setDepositScheduleData,
	saveEditOnPrice,
	setSaveEditOnPrice,
}) => {
	const [totalInstallment, setTotalInstallment] = useState(0);
	const [totalPercent, setTotalPercent] = useState(0);
	const [error, setError] = useState({});

	const param = useParams();

	const useStyles = makeStyles((theme) => ({
		textField: {
			border: 'none',
			boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1)',
			width: '100%',
		},
	}));
	const classes = useStyles();
	const onDateChange = (dateObj) => {
		let name = dateObj?.name;
		let value = dateObj?.value;
		var obj = depositScheduleData[name];
		if (!_.isNil(name) && !_.isNil(value) && value !== 'Invalid Date') {
			checkSequenceDepositDates(name, value);

			setDepositScheduleData({
				...depositScheduleData,
				[name]: {
					...obj,
					['date']: value,
				},
			});
			_.isEmpty(error)
				? setSaveEditOnPrice(true)
				: setSaveEditOnPrice(false);
		}
	};
	const onChange = (e) => {
		var obj = depositScheduleData[e.target.name];
		var fieldName = e.currentTarget.dataset.field;
		let depositCopy = { ...depositScheduleData };

		console.log('This is the value', fieldName, e.target.value);

		console.log('FIafjaf', e.currentTarget.name);

		function getPercentage(partialAmount, totalAmount) {
			var percentage =
				(Number(partialAmount) / Number(totalAmount)) * 100;

			return percentage;
		}

		if (fieldName === 'percentage') {
			console.log('I am ther percentage');
			let percentageVal = Number(e.target.value);
			if (Number(e.target.name) === 1 && percentageVal > 0) {
				console.log('here lol');
				setDepositScheduleData({
					...depositScheduleData,
					[e.target.name]: {
						...obj,
						[fieldName]: parseFloat(percentageVal),
						installment: parseInt(
							percentage(percentageVal, totalCost) -
								depositCopy[0]['installment']
						),
					},
				});
			} else if (percentageVal > 0) {
				console.log('not here lol');
				setDepositScheduleData({
					...depositScheduleData,
					[e.target.name]: {
						...obj,
						[fieldName]: parseFloat(percentageVal),
						installment: parseInt(
							percentage(percentageVal, totalCost)
						),
					},
				});
			}
		} else if (fieldName === 'installment') {
			let value = Number(e.target.value);
			if (value >= 0) {
				setDepositScheduleData({
					...depositScheduleData,
					[e.target.name]: {
						...obj,
						percentage: parseFloat(
							getPercentage(value, totalCost)
						).toFixed(1),
						[fieldName]: parseFloat(value),
					},
				});
			}
		} else {
			console.log('I am ther other data');
			setDepositScheduleData({
				...depositScheduleData,
				[e.target.name]: {
					...obj,
					[fieldName]: e.target.value,
				},
			});
		}
	};
	function checkSequenceDepositDates(index, input) {
		let errorList = error;
		let dateArr = _.map(depositScheduleData, function (el, key) {
			if (Number(key) === Number(index)) {
				return dayjs(input).unix();
			} else {
				return dayjs(el?.date).unix();
			}
		});
		let isSequential = dateArr.every(
			(num, i) => i === dateArr.length - 1 || num < dateArr[i + 1]
		);
		if (isSequential) {
			delete errorList['date'];
			setError(errorList);
		} else {
			setError({ ['date']: true });
		}
	}

	useEffect(() => {
		setDepositScheduleData({ ...depositSchedule });
	}, [depositSchedule]);

	useEffect(() => {
		if (_.isEmpty(error)) {
			setSaveEditOnPrice(true);
		} else {
			setSaveEditOnPrice(false);
		}
	}, [error]);

	useEffect(() => {
		console.log('This is the deposite schedule data', depositScheduleData);
		var depositScheduleDataKeys = Object.keys(depositScheduleData);

		var installmentTotal = 0;
		var percentageTotal = 0;

		depositScheduleDataKeys.forEach((key) => {
			var installment = depositScheduleData[key]['installment'];
			var percentage = depositScheduleData[key]['percentage'];

			installmentTotal = parseFloat(
				Number(installmentTotal) + Number(installment)
			);
			percentageTotal = Number(percentageTotal) + Number(percentage);
		});

		setTotalInstallment(installmentTotal);
		setTotalPercent(percentageTotal);
	}, [depositScheduleData]);

	return (
		<>
			<div className={styles.deposit_schedule_wrapper}>
				<Grid item container>
					<Grid item xs={4}></Grid>
					<Grid
						item
						xs={4}
						className={styles.header_item}
						alignContent='center'
					>
						Date
					</Grid>
					<Grid item xs={2} className={styles.header_item}>
						%
					</Grid>
					<Grid item xs={2} className={styles.header_item}>
						Amount
					</Grid>
				</Grid>
				{depositSchedule?.map((deposit, key) => {
					var depositNumber = key + 1;

					return (
						<>
							{/* <hr className={styles.separator}></hr> */}
							<Grid item container spacing={1}>
								<Grid item xs={4}>
									{capitalizeFirstLetter(
										stringifyNumber(depositNumber)
									)}{' '}
									deposit
								</Grid>
								<Grid item xs={4}>
									<CustomDateField
										name={key}
										value={
											depositScheduleData[key]?.date
												? new Date(
														depositScheduleData[key]
															?.date + 'T00:00:00'
												  )
												: null
										}
										onChange={onDateChange}
										error={error['date']}
										errorMessage={
											'Dates should be in sequence'
										}
										disablePast={true}
									/>
								</Grid>
								<Grid item xs={2}>
									<CustomTextField
										type='number'
										value={
											depositScheduleData[key]
												?.percentage ?? ''
										}
										onChange={onChange}
										name={key}
										inputProps={{
											'data-field': 'percentage',
											className: classes.textField,
										}}
										// error={true}
									/>
								</Grid>
								<Grid item xs={2}>
									<CustomTextField
										type='number'
										value={
											depositScheduleData[key]
												?.installment ?? ''
										}
										onChange={onChange}
										name={key}
										inputProps={{
											'data-field': 'installment',
											className: classes.textField,
										}}
									/>
								</Grid>
							</Grid>
						</>
					);
				})}
			</div>
			<div className={styles.total_wrapper}>
				<Grid container>
					<Grid item container>
						<Grid item xs={4} className={styles.total_item}>
							Total Deposit
						</Grid>
						<Grid item xs={4} className={styles.total_item}></Grid>
						<Grid item xs={2} className={styles.total_item}>
							{totalPercent.toFixed(2)}%
						</Grid>
						<Grid item xs={2} className={styles.total_item}>
							${numberWithCommas(totalInstallment.toFixed(2))}
						</Grid>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default EditPricingDeposit;
